// extracted by mini-css-extract-plugin
export default {"bubbleTitle":"ShareBubble__bubbleTitle--AQ4_g","bubbleText":"ShareBubble__bubbleText--2Plje","bubble":"ShareBubble__bubble--3_cNj","bubbleIcon":"ShareBubble__bubbleIcon--SZf8V"};